import { render, staticRenderFns } from "./ScrapingHistory.vue?vue&type=template&id=0a8a784e&"
import script from "./ScrapingHistory.vue?vue&type=script&lang=js&"
export * from "./ScrapingHistory.vue?vue&type=script&lang=js&"
import style0 from "./ScrapingHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports